/** Valor del `<select>` «Quién pagó» cuando el pago es desde cuenta conjunta (no titular personal). */
export const PAID_BY_JOINT_SELECT_VALUE = "__joint__" as const;

export function paidByPayloadFromSelectValue(
  value: string,
  opts?: { explicitDefaultPayerUserId?: string },
): {
  paidFromJointAccount?: boolean;
  paidByUserId?: string | null;
} {
  if (value === PAID_BY_JOINT_SELECT_VALUE) {
    return { paidFromJointAccount: true, paidByUserId: null };
  }
  if (value === "") {
    if (opts?.explicitDefaultPayerUserId) {
      return {
        paidFromJointAccount: false,
        paidByUserId: opts.explicitDefaultPayerUserId,
      };
    }
    return {};
  }
  return { paidFromJointAccount: false, paidByUserId: value };
}

export function paidBySelectValueFromExpense(e: {
  paidFromJointAccount?: boolean;
  paidByUserId?: string | null;
}): string {
  if (e.paidFromJointAccount === true) {
    return PAID_BY_JOINT_SELECT_VALUE;
  }
  return e.paidByUserId ?? "";
}
